import Vue from "vue";
import Vuex from "vuex";
// 导入createVuexPersistedState插件
import { createVuexPersistedState } from "vue-persistedstate";
import request from '../utils/request.js';
import apiService from '@/store/apiService'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // 2级导航默认激活的下标
    defaultActive: "1",
    // home的左侧导航栏是否折叠,true折叠，false不折叠
    collapse: false,
    unitList: [],
  },

  mutations: {
    // 修改defaultActive的值
    setDefaultActive(state, active) {
      state.defaultActive = active;
    },
    setCollapse(state, collapse) {
      state.collapse = collapse;
    },
    setUnitList(state, date) {
      state.unitList = date
    }
  },
  actions: {
    async axiosUnitList({ commit }) {
      await apiService.axiosUnitList({ commit })
    }
  },
  getters: {
    getUnitData: state => state.unitList,
  },
  modules: {},
  plugins: [
    // 使用vue-persistedstate插件使用localStorage实现状态的永久存储
    createVuexPersistedState({
      key: "default-active",
      storage: window.localStorage,
      whiteList: ["defaultActive", "collapse"],
      blackList: [],
    }),
  ],
});
